export class ReprocessProdReq {
    stockId : number;
    issuedQty : number;
    updatedUser : string;
    jobNumber : string;
    date : any

    constructor(stockId : number, issuedQty : number, updatedUser : string, jobNumber : string,date : any) {
        this.stockId = stockId;
        this.issuedQty = issuedQty;
        this.updatedUser = updatedUser;
        this.jobNumber = jobNumber;
        this.date = date;
    }


}